import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SignatureService {
  private apiUrl = `${environment.apiUrl}/trackvision/signature`;

  constructor(private http: HttpClient) { }

  private authHeaders(): HttpHeaders {
    return new HttpHeaders().set(
      'Token',
      localStorage.getItem('access_token') || ''
    );
  }

  getAvailableSignatures(): Observable<any> {
    return this.http.get(`${this.apiUrl}/available`, { headers: this.authHeaders() });
  }

  sendReminder(signatureId: string): Observable<{ success: boolean; message: string }> {
    return this.http.post<{ success: boolean; message: string }>(
      `${this.apiUrl}/${signatureId}/remind`,
      {},
      { headers: this.authHeaders() }
    );
  }
}
